/**
 * Build metadata.
 *
 * GENERATED FILE — do not edit. Rebuild with: npm run data:build
 *
 * See structure.ts / legible.ts for data attribution.
 */
export const DATA_META = {
  structureEntries: 5129,
  legibleEntries: 1177,
  variantEntries: 81,
  hash: "248ce2764477ecec",
} as const;
